/**
 * 建筑信息维护
 */
import React from 'react';
import moment from 'moment';
import { Row, Col, Select, DatePicker, Statistic } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
//加载中遮罩
import Loading from '../../ui/Loading';
import './berthSituationStyle.css';
import { EchartLine } from './EchartLine'
import { EchartBar } from './EchartBar'

class BuildingStatisticsIndex extends React.Component {

    columns = [{
        title: '市场（建筑）',
        dataIndex: 'buildingName',
        width: '10%',
    }, {
        title: '月份',
        dataIndex: 'month',
        width: '10%',
    }, {
        title: '商铺总数量',
        dataIndex: 'berthAmount',
        width: '10%',
    }, {
        title: '商铺总面积',
        dataIndex: 'totalArea',
        width: '10%',
    }, {
        title: '规划商铺总租金',
        dataIndex: 'rentalPlan',
        width: '10%',
    }, {
        title: '已租商铺数量',
        dataIndex: 'rentBerthAmount',
        width: '10%',
    }, {
        title: '已租面积',
        dataIndex: 'rentArea',
        width: '10%',
    }, {
        title: '租金',
        dataIndex: 'rental',
        width: '10%',
    }, {
        title: '空置的店面数量',
        dataIndex: 'vacantAmount',
        width: '10%',
    }, {
        title: '损失的租金',
        dataIndex: 'vacantRental',
        width: '10%',
    }];

    state = {
        loadingVisible: false,
        editData: {},
        buildingList: [],
        currentBuilding: "1",   //默认的市场建筑选项
        data: [],
        queryData: {},
        currentData: {},     //当前月份的数据
        monthArray: [],     //图表数据中的x轴
        vacantAmountList: null,
        rateList: null,
        vacantRentalList: null,
        LineData: {},
        value: [moment(moment().format("YYYY") + "-01", "YYYY-MM"), moment(moment().format("YYYY") + "-12", "YYYY-MM")],
        mode: ['month', 'month']
    };

    componentDidMount() {
        http.get({
            url: "/berth/findBuilding",
            success: (res) => {
                if (res) {
                    this.setState({ buildingList: res, currentBuilding: res[0]["id"] });
                }
                else {
                    this.setState({ buildingList: [], currentBuilding: "1" });
                }
            }
        });
        // let queryData = { buildingId: 1, startMonth: moment().startOf("year").format("YYYY-MM"), endMonth: moment().endOf("year").format("YYYY-MM") };
        let queryData = { buildingId: 1, startMonth: moment().format("YYYY") +"-01", endMonth: moment().format("YYYY") +"-12" };
        this.setState({ queryData: queryData });
        this.loadData(queryData);
        this.loadCurrentData(queryData.buildingId);
    }

    loadData = (queryData) => {
        http.get({
            url: "/building/statistics/query/list",
            data: queryData,
            success: (res) => {
                //计算月份
                const startMonth = queryData.startMonth;
                const endMonth = queryData.endMonth;
                let start = moment(startMonth, "YYYY-MM");
                let end = moment(endMonth, "YYYY-MM");
                let monthList = [];
                while (start.isBefore(end, "month") || start.isSame(end, "month")) {
                    monthList.push(start.format("YYYY-MM"));
                    start.add(1, "month");
                }
                //出租率
                let rateList = [];
                //损失租金
                let vacantRentalList = [];
                //空置店铺数量
                let vacantAmountList = [];
                res.forEach(item => {
                    //计算出租率
                    if (item.totalArea === 0) {
                        rateList.push(0);
                    }
                    else {
                        let rate = parseFloat((item.rentArea / item.totalArea * 100).toFixed(2));
                        rateList.push(rate);
                    }
                    vacantRentalList.push(item.vacantRental);
                    vacantAmountList.push(item.vacantAmount);
                });
                let rateChartData = this.getChartData('出租率', 'line', rateList, 'rentRateLine', monthList, "%");
                let vacantAmountChartData = this.getChartData('空置商铺', 'bar', vacantAmountList, 'vacantAmountBar', monthList, "个");
                let vacantRentalChartData = this.getChartData('损失租金', 'bar', vacantRentalList, 'vacantRentalBar', monthList, "元");
                this.setState({
                    data: res,
                    rateList: rateList,
                    vacantRentalList: vacantRentalList,
                    vacantAmountList: vacantAmountList,
                    rateChartData: rateChartData,
                    vacantAmountChartData: vacantAmountChartData,
                    vacantRentalChartData: vacantRentalChartData,
                });
                this.state.initChart();
                this.state.initChartBar1();
                this.state.initChartBar2();
            }
        });
    }

    getChartData = (name, type, rateList, id, xSeries, unit) => {
        let getData = [
            {
                name: name,
                type: type,
                data: rateList,
                itemStyle: {
                    normal: {
                        color: '#0096f3'
                    }
                },
                areaStyle: {},  // 折线下阴影背景
                label: {
                    normal: {
                        show: true,
                        position: 'top',
                        rotate: 45
                    }
                },

            }
        ];
        let optionData = {
            listData: getData,
            id: id,
            xSeries: xSeries,
            areaStyle: {},
            unit: unit
        };
        return optionData;
    }

    loadCurrentData = (buildingId) => {
        let currentMonth = new moment().format("YYYY-MM");
        http.get({
            url: "/building/statistics/query/one",
            data: { month: currentMonth, buildingId: buildingId },
            success: (res) => {
                this.setState({ currentData: res });
            }
        });
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    generate = () => {
        messager.confirm("是否生成对应时间段的统计数据？", () => {
            this.setState({ loadingVisible: true });
            http.post({
                url: '/building/statistics/generate',
                data: this.state.queryData,
                success: (res) => {
                    this.loadData(this.state.queryData);
                    this.setState({ loadingVisible: false });
                    messager.notify("生成数据成功！");
                },
                error: (res) => {
                    messager.alert(res.message, "异常", "error");
                    this.setState({ loadingVisible: false });
                }
            });
        });
    }

    handlePanelChange = (value, mode) => {
        let queryData = this.state.queryData;
        queryData.startMonth = value[0].format("YYYY-MM");
        queryData.endMonth = value[1].format("YYYY-MM");
        this.setState({
            value,
            mode: [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]],
            queryData: queryData
        });
        this.loadData(queryData);
    };

    selectChange = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.loadData(queryData);
        this.loadCurrentData(queryData.buildingId);
    }

    render() {
        const { currentData, value, mode } = this.state;
        //出租率，根据面积计算
        let rate = 0;
        if (currentData.totalArea && currentData.totalArea !== 0) {
            rate = (currentData.rentArea / currentData.totalArea * 100).toFixed(2) + "%";
        }
        return (
            <div style={{ width: '100%', height: '100%', overflow: 'auto' }} className="berth-div">
                <div className="berth-search">
                    <Row>
                        <Col span={20}>
                            <Select placeholder="市场" onChange={this.selectChange.bind(this, "buildingId")} defaultValue={this.state.currentBuilding} style={{ width: 200, marginRight: "10px" }}>
                                {this.state.buildingList.map(d =>
                                    <Select.Option key={d["id"]}>{d["buildingName"]}</Select.Option>
                                )}
                            </Select>
                            <DatePicker.RangePicker
                                // defaultValue={[moment().startOf("year"), moment().endOf("year")]}
                                value={value}
                                allowClear={false}
                                onChange={this.rangePickerChange}
                                mode={mode}
                                format='YYYY-MM'
                                onPanelChange={this.handlePanelChange} />
                        </Col>
                    </Row>
                </div>
                <div className="berth-head" key="hede">
                    <Row>
                        <Col span={3} className="head-statistic">
                            <Statistic title="铺位总面积" value={currentData.totalArea ? currentData.totalArea.toFixed(0) : 0} suffix="㎡" />
                        </Col>
                        <Col span={3} className="head-statistic">
                            <Statistic title="铺位数量" value={currentData.berthAmount} />
                        </Col>
                        <Col span={3} className="head-statistic">
                            <Statistic title="已出租面积" value={currentData.rentArea} suffix="㎡" />
                        </Col>
                        <Col span={3} className="head-statistic">
                            <Statistic title="已出租铺位数" value={currentData.rentBerthAmount} />
                        </Col>
                        <Col span={3} className="head-statistic">
                            <Statistic title="月租金" value={currentData.rental} />
                        </Col>
                        <Col span={3} className="head-statistic">
                            <Statistic title="空置店面数量" value={currentData.vacantAmount} />
                        </Col>
                        <Col span={3} className="head-statistic">
                            <Statistic title="空置损失租金" value={currentData.vacantRental} />
                        </Col>
                        <Col span={3} className="head-statistic">
                            <Statistic title="出租率" value={rate} />
                        </Col>
                    </Row>
                </div>
                <div style={{ width: '100%', marginTop: '40px', overflow: 'auto' }}>
                    {
                        this.state.rateChartData ? <div style={{ width: '100%', height: '400px' }}>
                            <EchartLine
                                echartId={this.state.rateChartData.id}
                                title={'出租率(已租面积/商铺总面积)'}
                                echartData={this.state.rateChartData}
                                initChart={(func) => { this.setState({ initChart: func }) }}
                            />
                        </div>
                            : ''
                    }
                </div>
                <div style={{ width: '100%', marginTop: '40px', overflow: 'hidden' }}>
                    {
                        this.state.vacantAmountChartData ? <div style={{ width: '100%', height: '400px' }}>
                            <EchartBar
                                echartId={this.state.vacantAmountChartData.id}
                                title={'空置商铺数量'}
                                echartData={this.state.vacantAmountChartData}
                                initChart={(func) => { this.setState({ initChartBar1: func }) }}
                            />
                        </div>
                            : ''
                    }
                </div>
                <div style={{ width: '100%', marginTop: '40px', overflow: 'hidden' }}>
                    {
                        this.state.vacantRentalChartData ? <div style={{ width: '100%', height: '400px' }}>
                            <EchartBar
                                echartId={this.state.vacantRentalChartData.id}
                                title={'空置损失租金'}
                                echartData={this.state.vacantRentalChartData}
                                initChart={(func) => { this.setState({ initChartBar2: func }) }}
                            />
                        </div>
                            : ''
                    }
                </div>
                {/* <Table rowKey="id"
                    columns={this.columns}
                    dataSource={this.state.data}
                    pagination={false}
                    style={{ border: '1px solid #e8e8e8', borderBottom: 0 }}
                /> */}
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中"
                />
            </div>
        )
    }
}

export default BuildingStatisticsIndex;